exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".approval[data-v-8078fb86]{padding:20px;position:relative;background:#fff}.footer[data-v-8078fb86]{border-top:1px solid #ccc;padding:15px}.custom-a[data-v-8078fb86]{color:#5597ec;text-decoration:underline}.custom-a[data-v-8078fb86]:hover{color:red}.content[data-v-8078fb86] .el-form-item{margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8078fb86","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./pages/console/dingComponents/Approval.vue
// module id = yHSr
// module chunks = 109